<header class="report-header">
	<h1 class="report-title">{{'truck_reports.truck_summary_report' | translate}}</h1>

	<div class="info-grid">
		<div class="info-row">
			<div class="info-cell"><strong>{{'truck_reports.date' | translate}}</strong> {{ toDayDate }}</div>
			<div class="info-cell"><strong>{{'truck_reports.truck_id' | translate}}</strong> {{device.config_info.truck_id}}</div>
		</div>
		<div class="info-row">
			<div class="info-cell"><strong>{{'truck_reports.site_name' | translate}}</strong> {{ currentSite.name }}</div>
			<div class="info-cell"><strong>{{'truck_reports.truck_sn' | translate}}</strong> {{device.config_info.truck_sn}}</div>
		</div>
		<div class="info-row">
			<div class="info-cell">
				<strong>{{'truck_reports.address' | translate}}</strong> {{ currentSite.address }}
			</div>
			<div class="info-cell"><strong>{{'truck_reports.manuf_date' | translate}}</strong> {{device.config_info.truck_manufacturing_year}}</div>
		</div>
		<div class="info-row">
			<div class="info-cell"><strong>{{'truck_reports.period' | translate}}</strong> {{ selectedPeriodFormatted }}</div>
			<div class="info-cell"><strong>{{'truck_reports.truck_manuf' | translate}}</strong> {{device.config_info.truck_manufacturer}}</div>
		</div>
		<div class="info-row">
			<div class="info-cell"><strong>{{'truck_reports.weeks_of_operation' | translate}}</strong> {{ weeksOfOperation }}</div>
			<div class="info-cell"><strong>{{'truck_reports.truck_type' | translate}}</strong> {{device.config_info.truck_type}}</div>
		</div>
		<div class="info-row">
			<div class="info-cell"><strong>{{'truck_reports.voltage_capacity' | translate}}</strong> {{nominalVoltage}} V / {{device.config_info.battery_capacity}} Ah</div>
			<div class="info-cell"></div>
		</div>
	</div>
</header>